import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ToggleSidenavCollapsedAction } from 'src/app/actions/sidenav.actions';
import { Sidenav } from 'src/app/models/sidenav.model';
import { SidenavItem } from 'src/app/shared/enums/sidenav-item.enum';
import { environment } from 'src/environments/environment';
import * as fromRoot from '../../../reducers';
import {AlertCount} from '../../../models/alert-count';
import {SearchComponent} from "../../search/search.component";
import {AsyncPipe, NgClass} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {MatIcon} from "@angular/material/icon";
import {MatButton} from "@angular/material/button";
import {MatDivider} from "@angular/material/divider";
import {SettingsComponent} from "../../settings/settings.component";
import {MatBadge} from "@angular/material/badge";

@Component({
  selector: 'colimo-mobile-sidenav',
  templateUrl: './mobile-sidenav.component.html',
  styleUrls: ['./mobile-sidenav.component.scss'],
  imports: [
    SearchComponent,
    NgClass,
    MatIcon,
    MatButton,
    TranslateModule,
    AsyncPipe,
    MatDivider,
    SettingsComponent,
    MatBadge
  ]
})
export class MobileSidenavComponent implements OnInit {
  @Input() public alertCount: AlertCount;
  @Input() public alertsConfigured: boolean;
  @Output() public initiateLogout = new EventEmitter<void>();
  public sidenavCollapsed: boolean;
  public adminToolPath: string;
  public sidenav$: Observable<Sidenav>;
  public sidenavItems = SidenavItem;

  constructor(private router: Router, private store: Store<fromRoot.State>) {}

  public ngOnInit(): void {
    this.sidenav$ = this.store.select(fromRoot.getSidenav);
    this.store.select(fromRoot.getSidenav).subscribe((sidenav: Sidenav) => {
      this.sidenavCollapsed = sidenav.sidenavCollapsed;
    });
    this.adminToolPath = environment.adminPath;
  }

  public openView(route: SidenavItem) {
    this.router.navigate(['/' + route]);
    this.closeSidenav();
  }

  public closeSidenav(): void {
    this.store.dispatch(new ToggleSidenavCollapsedAction(true));
  }

  public logout(): void {
    this.initiateLogout.emit();
  }
}
